import update from 'immutability-helper'
// import {getTemplate} from './translation'



const IGNORE_FLAG = '_'
const SPECIAL_FLAG = '!'
const TEMPLATE_FLAG = '--'
const REF_NULL = '!NUL!'
const REF_BLOCK_FLAG = '==>'
const REF_FLAG = '$$'
const MASK_FLAG = `${IGNORE_FLAG}mask`
const NAME_FLAG = `${IGNORE_FLAG}name`
const PRIMARY_SHEET_FLAG = '(Primary)'
const BLANK = {[NAME_FLAG]: '', [`${IGNORE_FLAG}blank`]: true}
const WHY_FLAG = '$'
// This object is self-referential, in order to affect every item below it in
// the hierarchy
const MUL_VALS = {[NAME_FLAG]: '[Multiple Values]', [MASK_FLAG]: '(Multiple Values)', [`${IGNORE_FLAG}mult`]: true}
MUL_VALS.mv = [MUL_VALS]
// const clone = x => JSON.parse(JSON.stringify(x))
const getValidProps = tpl => Object.keys(tpl).filter(e => e[0] !== IGNORE_FLAG && e[0] !== WHY_FLAG && e[0] !== SPECIAL_FLAG)

const getCont = (cont, forceName = false, idx = 0) => {
  if( cont[idx] )
    return forceName?
      cont[idx][NAME_FLAG]:
      cont[idx][MASK_FLAG] || cont[idx][NAME_FLAG]
  return forceName?
    cont[NAME_FLAG]:
    cont[MASK_FLAG] || cont[NAME_FLAG]
}


// Fetches a source from a source object given that source's address
const getSourceFromAddress = (sources, address)=>{
  // console.log(sources, address)
  // console.log('fetch %s from', address, sources)
  if( !address ) return null
  if( !sources ) return null
  // console.log(address)
  let [zone, name] = address.split('.')
  let zonedSource
  if( zone && sources[zone] ){
    zonedSource = sources[zone]
  }
  if( name && zonedSource && zonedSource[name] ){
    return zonedSource[name]
  } else {
    if( Array.isArray(zonedSource) ) return zonedSource
    // if( zone === '$parent' && zonedSource ) {
    //   console.log('zone is parent, zonedSource is', zonedSource)
    //   return []
    // }
    else return null
  }
  // console.log('got source', source)
}

// You want documentation? Screw you, my code is self documenting
const traverseSchema = function(schema, originalSource, tree, callback){
  // console.trace('scanning', schema)
  let source = originalSource
  let scanSchemaLayer = function(sch, src, hierarchyChain = [], parentSource, parentIdx){
    let success = false
    let scanned = false

    let genMapOpt = function(curSrc, control){
      return opt => {
        let idx = curSrc && curSrc.length? curSrc.findIndex( v => v._name === opt._name ): -1
        if( control.children ){
          //console.log(`${control.name} added itself to hierarchy as an option`)
          hierarchyChain = [...hierarchyChain, control.name]
        }
        if( ~idx && control.children ) {
          src['$parent'] = curSrc[idx]
          //console.log(`control ${control.name} with children and no val scanning layer`)
          scanSchemaLayer(control.children, src, hierarchyChain.slice(0), curSrc, idx)
          //console.log(`control ${control.name} finished childed valueless scan`)
          scanned = true
        } else if( control.children ){
          // console.log(`control ${control.name} with children scanning layer`)
          scanSchemaLayer(control.children, src, hierarchyChain.slice(0), curSrc, idx)
          // console.log(`control ${control.name} finished childed valued scan`)
          scanned = true
        } else if( !control.children ){
          let hierIdx = hierarchyChain.indexOf(control.name)
          if( ~hierIdx ) hierarchyChain = [...hierarchyChain.slice(0, hierIdx), ...hierarchyChain.slice(hierIdx + 1)]
        }
      }
    }

    for( let controlIdx in sch ) {
      //console.log('in traverse schema', controlIdx, sch[controlIdx])
      // console.log('traversing control', sch[controlIdx].name)

      // if( controlIdx === '_updated' ) continue
      if( success ) return
      let control = sch[controlIdx]
      // console.log(control)
      let sourceAddr = control.source || ''
      // if( !sourceAddr ) {
      //   if( control.children && !success ){
      //     //console.log(`control ${control.name} scanning, probably page`)
      //     scanSchemaLayer(control.children, src, hierarchyChain.slice(0))
      //     // console.log(`control ${control.name} done page scan`)
      //     continue
      //   }
      //   sourceAddr = ''
      // }
      // console.log('starting getSource')
      // console.log(source, sourceAddr)
      let curSrc = getSourceFromAddress(source, sourceAddr)
      // console.log('finished', curSrc)
      // console.log("before executing genMapOpt")
      let mapOpt = genMapOpt(curSrc, control)
      // if( haveSource ){
      //   trueSrc = src[zone][name]
      // }
      let leaf = tree[control.name]
      //console.log('before callback')
      let [zone, name] = sourceAddr.split('.')
      let parentItem = null
      if( parentSource && ~parentIdx ){
        // console.log('in parentSource if with', parentSource, parentItem, zone, name)
        parentItem = parentSource[parentIdx]
      }
      let ctrl = typeof control === 'string'? control: {...control, schIdx: controlIdx}

      let res = callback(ctrl, curSrc, hierarchyChain, tree, parentItem)
      // res can return any number of the following inside an object:
      // source: updates the source of this specific control
      // control: updates the schema description of this specific control
      // success: if true, signifies that work is done and execution can stop

      if( res ) {
        if( res.control ) {
          if( typeof sch !== 'string')
            sch[controlIdx] = res.control
        }
        if( res.success ) {
          success = res.success
        }
        if( res.source ){
          // console.log('requested source set to', res.source)
          // console.log(source, zone, name)

          if( zone && !name ){
            source[zone] = res.source
            // source = update(source, {
            //   [zone]: {'$set': res.source}
            // })
            // console.log('set content directly to source zone', zone, source)
          } else if( zone && name ){
            // console.log('begin source zone/name')
            if( zone === '$parent' ){
              // console.log(parentSource, parentIdx, name)
              // console.log('detected parent')
              if( parentSource && ~parentIdx ){
                // console.log('setting parent source manually')
                parentSource[parentIdx] = parentSource[parentIdx] || {}
                parentSource[parentIdx][name] = res.source

              }
              // parentSource = update(parentSource, {
              //   [parentIdx]: {
              //     [name]: {'$set': res.source}
              //   }
              // })
              // console.log(parentSource)
            } else {
              source[zone] = source[zone] || {}
              source[zone][name] = source[zone][name] || []
              // source[zone][name] = res.source
              // console.log('set source at zone and name to source:', zone, name)
              // console.log(res.source)
              source = update(source, {
                [zone]: {
                  [name]: {'$set': res.source}
                }
              })

            }


            // console.log('set source to' , source, source[zone][name])
          }
        }
      }
      // console.log('looking at leaf', leaf)
      let idx = parentIdx
      if( leaf && leaf.content && !success ){
        let val = Array.isArray(leaf.content)? leaf.content: [leaf.content]
        if( val.length ) {
          // console.log('parsing control %s values', control.name, val)
          val.map(mapOpt)
        } else {
          // console.log(val)
          // console.log('looking for %s in', val._name, curSrc)
          idx = (curSrc && curSrc.findIndex( v => v._name === val._name )) || -1
          if( control.children ){
            if( ~idx ){
              src['$parent'] = curSrc[idx]
            }
          }
        }
      }
      // if( control.children ){
      //   hierarchyChain = [...hierarchyChain, control.name]
      //   console.log(`${control.name} adds self to chain`, hierarchyChain)
      //
      // }
      if( !control.source ){
        curSrc = parentSource
        idx = parentIdx
      }
      if( !scanned && !success ) {
        // console.log(`control ${control.name} hasn't been scanned, so we scan it`)
        if( !control.children )
          scanSchemaLayer(control.children, src, hierarchyChain.slice(0), curSrc, idx)
        else
          scanSchemaLayer(control.children, src, [...hierarchyChain, control.name], curSrc, idx)
        // console.log(`control ${control.name} undone scanning complete`)

      }
      //if( ~hierIdx ) hierarchyChain = [...hierarchyChain.slice(0, hierIdx), ...hierarchyChain.slice(hierIdx + 1)]
    }
  }
  // console.log('running initial schema scan')
  scanSchemaLayer(schema, originalSource, [])
  // console.log('inital scan done')
  // console.log('returning source', source)
  const res = {schema, source, tree}
  // console.log('finished traversal', res)
  return res
  // console.log('finsihed schema scan')
}

const getPureAddress = function(addr){
  return addr.split('.').filter(isNaN).join('.')
}

// Traverses the entire source regardless of tree or schema
const traverseSource = function(source, cb){
  let sourceZones = getValidProps(source)
  function scanSourceLayer(layer, layerName, address = '', parentItem){
    // console.log('check layer', layer)
    for( let lineItemIdx in layer ){
      const ownAddr = `${layerName}.${lineItemIdx}`
      // const ownAddr = layerName
      address = address? `${address}.${ownAddr}`: `${ownAddr}`
      let lineItem = layer[lineItemIdx]
      if( Array.isArray(lineItem) ){
        layer[lineItemIdx] = scanSourceLayer(lineItem, lineItemIdx, address, layer)
      } else {

        let res = cb(lineItem, address, parentItem)
        if( res ){
          // backdoor to return immediately
          if( res === '!done' ) return
          layer[lineItemIdx] = res
        }
        if( lineItem._name ){
          let validProps = getValidProps(lineItem)
          for( let propName of validProps ){
            lineItem[propName] = scanSourceLayer(lineItem[propName], propName, address, lineItem)
          }
        }
        address = address.substr(0, address.length - ownAddr.length - 1)
      }
    }
    return layer
  }
  let obj = {}
  // console.log('scan source zones', sourceZones)
  for( let propName of sourceZones ){
    // console.log('check propname', propName, source[propName])
    obj[propName] = scanSourceLayer(source[propName], propName)
    // console.log('with result', obj[propName])
  }
  return obj
}

// Checks whether two sets of standard element sources are equal to one another,
// based on their _name attributes, total number of keys (MAY be a pitfall), and
// the same going downward, recursively.
const sourceElmsEqual = (firstElm, secondElm) => {
  const expandString = elm => typeof elm === 'string'? {[NAME_FLAG]:elm}: elm

  // get relevant keys
  firstElm = expandString(firstElm)
  secondElm = expandString(secondElm)
  // console.log('check equality', firstElm, secondElm)
  let keys = getValidProps(firstElm)
  if( keys.length !== getValidProps(secondElm).length) return false

  for( let key of keys ){
    let firstSource = firstElm[key]
    let secondSource = secondElm[key]
    return sourceArraysEqual(firstSource, secondSource)
  }
  return true
}

const sourceArraysEqual = (firstSource, secondSource) => {
  if( firstSource.length !== secondSource.length ) return false
  for( let elmIdx in firstSource ){
    let firstComp = firstSource[elmIdx]
    let secondComp = secondSource[elmIdx]
    // console.log('checking %s and', firstComp._name, secondComp._name)
    if( typeof firstComp !== typeof secondComp ) return false
    if( typeof firstComp === 'string' ) return firstComp === secondComp
    if( firstComp._name !== secondComp._name ) return false
    if( firstComp._mask !== secondComp._mask ) return false
    if(!sourceElmsEqual(firstComp, secondComp)) return false
  }
  return true
}

// accepts two source items and returns items from source2 that differ from
// source1
const excludeSource = function(firstElm, secondElm){
  // console.log('excluding source')
  let res = {}
  if( !firstElm || !secondElm ) return res
  if( firstElm._name !== secondElm._name ) {
    res._name = secondElm._name
  }
  if( secondElm._mask && firstElm._mask !== secondElm._mask ){
    res._mask = secondElm._mask
  }
  let props = getValidProps(secondElm)
  for( let prop of props ){
    let e = secondElm[prop]
    if( !firstElm[prop] || !sourceArraysEqual(firstElm[prop], e) ) {
      // console.log('two elements are NOT equal', firstElm[prop], secondElm[prop])
      res = update(res, {
        [prop]: {'$set': e}
      })
      // console.log(res)
    }
  }
  return res
}

const mergeIntoSource = function(originElm, targetElm){
  // console.trace('I AM RUNNING', originElm, targetElm)
  // console.log('merging', clone(originElm), clone(targetElm))
  if( typeof targetElm === 'string' ) return targetElm
  let res = update({}, {
    '$set': originElm
  })
  // console.log('get valid props of this elm', targetElm)
  let props = getValidProps(targetElm)
  // console.log(props)
  for( let prop of props ){

    // console.log(prop, res[prop], res)
    // console.log('assigning to %s:',prop, targetElm[prop], targetElm)
    if( !res[prop] ) res[prop] = targetElm[prop]
    else {
      for( let child of targetElm[prop] ){
        // console.log('check', res[prop], prop)
        let idx = res[prop].findIndex(e => {
          return typeof child === 'string'?
            e === child:
            e._name === child._name
        })
        if(~idx){
          res = update(res, {
            [prop]: {
              [idx]: {'$set': mergeIntoSource(res[prop][idx], child)}
            }
          })
        } else {
          res[prop].push(child)
        }
      }
    }
  }
  return res
}

const switchControlReadOnly = function(schema, toggle){
  if( toggle ){
    schema = traverseSchema(schema, {}, {}, control => {
      control = update(control, {
        options: {'$set': [{_name: 'show-original-templates'}]}
      })
      if( !control.options ){
        control = update(control, {
          options: {'$set': [{_name: 'show-original-templates'}]}
        })
      }
      if( !control.options.filter(elm => elm._name === 'read-only' || elm === 'read-only').length ){
        control = update(control, {
          options: {'$push': [{_name: 'show-original-templates'}]}
        })
      }
      return {control}
    }).schema
  } else {
    schema = traverseSchema(schema, {}, {}, control => {
      if( control.options){
        control = update(control, {
          options: {'$set': control.options.filter(elm => elm !== 'read-only' && elm._name !== 'read-only')}
        })
        // control.options=control.options.filter(elm => elm !== 'read-only' && elm._name !== 'read-only')
      }
      return {control}
    }).schema
  }
  return schema
}

const mergeAll = function(a, b){
  // console.log('merging', a, b)
  const keysA = Object.keys(a)
  for( const key of keysA) {
    if( !b[key] ){
      b[key] = a[key]
    }
    if( Array.isArray(b[key]) ){
      if( !Array.isArray(a[key] ))
        throw new Error('mergeAll: Incompatible types!')
      else {
        // Subset of unique values
        const allItems = {}
        const arr = [...a[key], ...b[key]]
        arr.forEach(item => allItems[item._name] = item)
        const namesA = a[key].map(elm => elm._name)
        const namesB = b[key].map(elm => elm._name)
        const unique = [...new Set([...namesA, ...namesB])]
        b[key] = unique.map(name => allItems[name])
      }
    } else if( typeof b[key] === 'object' ){
      if( typeof a[key] !== 'object' )
        throw new Error('mergeAll: Incompatible types!')
      else
        b[key] = {
          ...b[key],
          ...a[key]
        }
        if( a._mask ){
          b._mask = a._mask
        }
    }
  }
  return b
}

const chainJoin = function(elms){
  // console.log('chain join elms', elms)

  elms = elms.map(elm => {
    if( elm[0] && elm[0].source ) return elm[0].source
    return elm
  })

  let res = elms[0]
  let myElms = [...elms.slice(1)]
  for( const elm of myElms ){
    const bindingProps = Object.keys(elm)
    for( const prop of bindingProps ){
      res = joinSourcesByName(res, elm, prop)
    }
  }
  // console.log('resultant lang', res)
  return res
}


const joinSourcesByName = function(dest, src, prop){
  // console.log('join by prop %s', prop)
  // console.log('dest', dest)
  // console.log('src', src)
  let mySrc = src
  const res = traverseSource(dest, function(destElm, destAddr){
    if( !prop || destAddr.includes(prop) ){
      let joinLocations = []
      traverseSource(mySrc, function(srcElm, srcAddr){
        if( srcElm._name === destElm._name ){
          joinLocations.push(srcAddr)
          destElm = mergeAll(srcElm, destElm)
          destElm = mergeAll(destElm, srcElm)
        }
      })
      return destElm
    }
  })
  // console.log('returning joined elm', res)
  return res
}


const joinSourcesByPropertyNames = function(dest, arr, keyName){
  // console.log('attempt join')
  // console.log(arr)
  // console.log(keyName)
  // console.log('traversing dest', dest)
  return traverseSource(dest, (sourceElement, address) => {
    // console.log(address)
    // console.log(sourceElement)
    let keys = Object.keys(sourceElement).filter(item => item[0] !== '_')
    if( keys.length && keys.includes(keyName) ){
      if(sourceElement[keyName] ){
        // check whether this item's content matches any of the second array's
        // objects
        let key = sourceElement[keyName][0]
        let res = arr.filter(item => item._name === key._name)
        if( res.length ){
          let toMerge = res[0]
          let validKeys = Object.keys(toMerge).filter(item => item[0] !== '_')
          for( let validKey of validKeys ){
            sourceElement[validKey] = toMerge[validKey]
          }
          return sourceElement
        }
      }
    }
  })
}

const splitSourceTemplates = (source)=>{
  // console.log('splitting', source)
  let templates = {}, includes = {}
  if( source._templates ){
    templates = source._templates
    // source = update(source, {'$unset': ['_templates']})
  }
  if( source._includes ){
    includes = source._includes
  }
  return {source, templates, includes}
}

const genId = (() =>
  // Good luck!
  // https://stackoverflow.com/a/37438675/1798148
  (m = Math, d = Date, h = 16, s = x => m.floor(x).toString(h)) => // eslint-disable-line
  s(d.now() / 1000) + ' '.repeat(h).replace(/./g, () => s(m.random() * h)))()

if( typeof window !== 'undefined' ) {
  window._ms_traverseSource = traverseSource
  window._ms_joinChain = chainJoin
  window._ms_mergeAll = mergeAll
  window._ms_joinName = joinSourcesByName
}

export {
  BLANK,
  REF_FLAG,
  REF_NULL,
  MUL_VALS,
  MASK_FLAG,
  NAME_FLAG,
  IGNORE_FLAG,
  SPECIAL_FLAG,
  TEMPLATE_FLAG,
  REF_BLOCK_FLAG,
  PRIMARY_SHEET_FLAG,
  joinSourcesByPropertyNames,
  switchControlReadOnly,
  getSourceFromAddress,
  splitSourceTemplates,
  sourceArraysEqual,
  mergeIntoSource,
  sourceElmsEqual,
  traverseSource,
  traverseSchema,
  getPureAddress,
  getValidProps,
  excludeSource,
  chainJoin,
  getCont,
  genId
}
